/* eslint eqeqeq: 0 */

import React, { Component } from "react";
//import route from 'routes/routes'
import MainPage from "./components/MainPage/MainPage";
import "./App.css";
import "moment/locale/es";
import "moment/locale/fr";
import moment from "moment";
import { getLanguageLocal } from "./Language/language.service";
import api from "./reduxRelated/middleware/api";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
/* import { BrowserRouter as Router} from 'react-router-dom'; */
import rootReducer from "./reduxRelated/reducer/index.js";
import "react-table/react-table.css";
import "react-day-picker/lib/style.css";
import "react-toastify/dist/ReactToastify.css";
import FixedAppLookupsContextProvider from "./components/FixedAppLookupsProvider";
import StateRetentionContextProvider from "./components/StateRetentionProvider";
import ScrollToTop from "./components/Common/ScrollToTop";
import { sessionService } from "./services/session.js";

let createStoreWithMiddleware = applyMiddleware(thunkMiddleware, api)(createStore);
let store = createStoreWithMiddleware(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

moment.locale(getLanguageLocal());

class App extends Component {
  constructor(props) {
    super(props);
    this.handleStorageChange = this.handleStorageChange.bind(this);
    this.state = { tempSessionToken: null };
    this.initializeMobileAppSession = this.initializeMobileAppSession.bind(this);
    this.isMobileAppSessionExpired = this.isMobileAppSessionExpired.bind(this);
  }
  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get("access_token") && urlParams.get("source") === "MobileApp") {
      if (this.isMobileAppSessionExpired(urlParams)) {
        window.location.replace("/appSessionExpire");
        localStorage.setItem("issuedAt", Math.floor(Date.now() / 1000)); // case : expire the valid tab when previous is opened
        return;
      }

      this.initializeMobileAppSession(urlParams);
    }

    window.addEventListener("storage", this.handleStorageChange);
  }

  handleStorageChange = (event) => {
    const isApp = localStorage.getItem("source") === "MobileApp";
    const accessTokenChangedWeb = event.key === "access_token" && !isApp;
    const accessTokenChangedApp = event.key === "access_token" && isApp;
    if (accessTokenChangedWeb) {
      window.location.replace(window.location.origin);
    } else if (accessTokenChangedApp) {
      window.location.replace("/appSessionExpire");
    }
    if (event.key === "mobile_session_version" || event.key === "issuedAt") {
      localStorage.removeItem("loggedInUser");
      sessionService.clearSessionStorage();
      window.location.replace("/appSessionExpire");
    }
  };
  componentWillUnmount() {
    window.removeEventListener("storage", this.handleStorageChange);
  }
  isMobileAppSessionExpired(urlParams) {
    const tsParam = urlParams.get("issuedAt");
    const oldTs = Number(localStorage.getItem("issuedAt"));

    if (!tsParam) return true;

    const ts = Number(tsParam);
    if (Number.isNaN(ts)) return true;

    // Older session check
    if (oldTs && oldTs > ts) return true;

    // Expiry check (2 minutes)
    const issuedAtMs = ts * 1000;
    const diffSeconds = (Date.now() - issuedAtMs) / 1000;

    return diffSeconds > 120;
  }
  initializeMobileAppSession(urlParams) {
    const token = urlParams.get("access_token");
    const ts = Number(urlParams.get("issuedAt"));

    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("access_token");

    sessionService.setToken(token);

    localStorage.setItem("source", urlParams.get("source"));
    localStorage.setItem("language", urlParams.get("language"));
    localStorage.setItem("theme", "retro");
    localStorage.setItem("issuedAt", ts);
    localStorage.setItem("mobile_session_version", Date.now());

    this.setState({ tempSessionToken: token });
  }

  render() {
    return (
      <Provider store={store}>
        <FixedAppLookupsContextProvider tempSessionToken={this.state.tempSessionToken}>
          <StateRetentionContextProvider>
            <ScrollToTop />
            <MainPage />
          </StateRetentionContextProvider>
        </FixedAppLookupsContextProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js